import { useCalendarDayNow } from '@/utils/conversationDayLabel'
import { useChatThreadEdit } from '@/components/Chat/ChatThreadView/useChatThreadEdit'
import { useChatThreadExchanges } from '@/components/Chat/ChatThreadView/useChatThreadExchanges'
import { useChatThreadPreamble } from '@/components/Chat/ChatThreadView/useChatThreadPreamble'
import { useChatThreadSpeech } from '@/components/Chat/ChatThreadView/useChatThreadSpeech'

export function useThreadsSearchDialogPreviewThread(messages, threadId) {
  const calendarNow = useCalendarDayNow()
  const edit = useChatThreadEdit({ activeThreadId: threadId })
  const preamble = useChatThreadPreamble(threadId, messages)
  const speech = useChatThreadSpeech()
  const { exchanges, getExchangeDisplayUser } = useChatThreadExchanges(messages, {})
  return {
    calendarNow,
    edit,
    preamble,
    exchanges,
    getExchangeDisplayUser,
    startSpeech: speech.startSpeech,
  }
}
